import { $http } from '@/utils';

/**
 * @namespace Service
 * @class KFI
 * @exports Service/Cms/KFI
 * @description API KFI Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class KFI {
	/**
	 * @static @name get
	 * @description Get KFI using name
	 * @param {String} id
	 * @returns {Object} Promise a http response
	 */
	static get(name, cache = true) {
		return $http.get(`cms/kfi/${name}`, {
			cache,
			cachePath: `cms-kfi-${name}`
		});
	}
}
